import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Notice } from '@teliaee/design-system';
import useStores from '../stores/UseStores';

const UpdateSoftwareNotice = observer((): React.ReactNode => {
  const {
    translateStore: { translate },
  } = useStores();
  return (
    <Notice type="error">
      {translate('idcard.oldSoftware.prefix')}{' '}
      <Button
        ariaLabel={translate('idcard.oldSoftware.ariaLabel')}
        link
        url={translate('idcard.oldSoftware.link')}
        isUnderlined
        external
        target="_blank"
        iconRight="#new-window"
        text={translate('idcard.oldSoftware.linkText')}
      />{' '}
      {translate('idcard.oldSoftware.suffix')}
    </Notice>
  );
});
export default UpdateSoftwareNotice;
